import axios from "axios";
import router from "@/router";
import store from "@/store";
import {
    Message
} from "element-ui";

const defaultConfig = {
    validateStatus: function(status) {
        return status < 300;
    },
    responseType: "json",
    responseEncoding: "utf8",
    timeout: 60 * 1000,
    baseURL: process.env.VUE_APP_URL,
    withCredentials: false,
    headers: {
        'content-Type': "application/json;charset=UTF-8",
        'Access-Controll-Allow-Origin': '*'
    },
}

const http = axios.create(defaultConfig)

let pending = []; //声明一个数组用于存储每个ajax请求的取消函数和ajax标识
let cancelToken = axios.CancelToken;
let removePending = (ever) => {
    for (let p in pending) {
        if (pending[p].u === ever.url + "&" + ever.method) {
            //当当前请求在数组中存在时执行函数体
            pending[p].f(); //执行取消操作
            pending.splice(p, 1); //把这条记录从数组中移除
        }
    }
};

// 添加请求拦截器
http.interceptors.request.use(
    (config) => {
        // 每次发起请求前取消掉在进行中的相同请求
        removePending(config);
        config.cancelToken = new cancelToken((c) => {
            // 这里的ajax标识我是用请求地址&请求方式拼接的字符串，当然你可以选择其他的一些方式
            pending.push({
                u: config.url + "&" + config.method,
                f: c
            });
        });
        // 自动添加token, 登录接口不传
        if (store.getters.user.token && config.url.search("login") == -1) {
            config.headers.Authorization = `Bearer ${store.getters.user.token}`;
        }
        if (config.url.search('export') != -1 || config.url.search('excel') != -1) {
            // 导出到excel里时，需要设置返回类型为二进制数据
            config.responseType = "blob"
        }
        return config;
    },
    (error) => {
        Message.error("请求超时");
        return Promise.reject(error);
    }
);
// 添加返回拦截器
http.interceptors.response.use(
    (response) => {
        //在一个ajax响应后再执行一下取消操作，把已经完成的请求从pending中移除
        removePending(response.config);
        let code = response.data.code || response.status
        switch (code) {
            case 200:
                // 返回正常的数据
                return Promise.resolve(response.data ? response.data : response);
            default:
                break;
        }
        Message.error(response.data.msg)
        return Promise.reject(response.data);
    },
    (error) => {
        if (error.response) {
            switch (error.response.status) {
                case 401:
                    Message.error("登录超时,请重新登录!");
                    store.dispatch("user/logout");
                    localStorage.clear();
                    setTimeout(() => {
                        router.replace({
                            path: '/login',
                        });
                    }, 1000);
                case 404:
                    Message.error("请求地址不存在！");
                    break
                case 403:
                    Message.error("登录过期，重新登录！");
                    store.dispatch("user/logout");
                    localStorage.clear();
                    setTimeout(() => {
                        router.replace({
                            path: '/login',
                        });
                    }, 1000);
                    break
                case 502:
                    Message.error("请求服务器出错");
                default:
                    // if(error.response.data){
                    //     Message.error(error.response.data.message);
                    // }
                    Message.error(error.response.data.message || "服务器维护中，请稍后再试！");
                    
                    break
            }
        }
        return Promise.reject(error);
    }
);

export function get(url, params = {}) {
    return new Promise((resolve, reject) => {
        http.get(url, {
                params: params
            })
            .then(resolve)
            .catch(reject)
    })
}

export function post(url, params = {}) {
    return new Promise((resolve, reject) => {
        if (params.file != undefined) {
            // 有上传文件
            let formData = new FormData()
            for (const key in params) {
                formData.append(key, params[key])
            }
            let config = defaultConfig
            config.headers["content-Type"] = "multipart/form-data"
            http.post(url, formData, config).then(resolve).catch(reject)
        } else {
            http.post(url, JSON.stringify(params))
                .then(resolve)
                .catch(reject)
        }
    })
}
export function put(url, params = {}) {
    return new Promise((resolve, reject) => {
        http.put(url, JSON.stringify(params))
            .then(resolve)
            .catch(reject)
    })
}

export function del(url, params = {}) {
    return new Promise((resolve, reject) => {
        http.delete(url, JSON.stringify(params))
            .then(resolve)
            .catch(reject)
    })
}

export default http